import { UPDATE_SOURCE } from './constants';

export function generateUpdate({
  current,
  time,
  cardId,
  cardMessage,
  cardPhotoUrl,
  cardImageId,
  cardExternalSrc,
}) {
  if (current) {
    if (current.photo === cardPhotoUrl) {
      return {
        ...current,
        source: UPDATE_SOURCE.SMARTPAGE,
        updatedTime: time,
        message: cardMessage,
      };
    }

    return {
      ...current,
      source: UPDATE_SOURCE.SMARTPAGE,
      updatedTime: time,
      message: cardMessage,
      photo: cardPhotoUrl,
      imageId: cardImageId,
      externalSrc: cardExternalSrc,
    };
  }

  return {
    id: cardId,
    source: UPDATE_SOURCE.SMARTPAGE,
    createdTime: time,
    message: cardMessage,
    photo: cardPhotoUrl,
    imageId: cardImageId,
    externalSrc: cardExternalSrc,
  };
}

export function mapUpdateToCard(update) {
  return {
    message: update.message,
    photo: update.photo,
    imageId: update.imageId,
    time: update.createdTime,
  };
}
